"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBridFromChainException = exports.SerializedTransactionFormatException = exports.InvalidTxRidException = exports.UnexpectedStatusError = exports.TxRejectedError = exports.GetTransactionRidException = exports.InvalidTransactionFormatException = exports.FilteredNodeUrlPoolEmptyError = exports.DirectoryNodeUrlPoolException = exports.BlockchainUrlUndefinedException = exports.MissingNodeUrlError = exports.MissingBlockchainIdentifierError = exports.MissingPubKeyError = void 0;
const customError_1 = require("../customError");
const formatter_1 = require("../formatter");
class MissingPubKeyError extends customError_1.CustomError {
    constructor() {
        super(`No public key was provided`, 400);
    }
}
exports.MissingPubKeyError = MissingPubKeyError;
class MissingBlockchainIdentifierError extends customError_1.CustomError {
    constructor() {
        super(`No blockchain identifier was provided. Include either a blockchainRid (string) or a blockchainIid (number).`, 400);
    }
}
exports.MissingBlockchainIdentifierError = MissingBlockchainIdentifierError;
class MissingNodeUrlError extends customError_1.CustomError {
    constructor() {
        super(`No node url or directory node url was provided. Include either a nodeUrl (string or string[]) or a directory node url (string or string[]).`, 400);
    }
}
exports.MissingNodeUrlError = MissingNodeUrlError;
class BlockchainUrlUndefinedException extends customError_1.CustomError {
    constructor(brid) {
        const idType = typeof brid === "string" ? "BRID" : "IID";
        super(`Cannot find nodes hosting the blockchain with ${idType} ${brid}`, 400);
    }
}
exports.BlockchainUrlUndefinedException = BlockchainUrlUndefinedException;
class DirectoryNodeUrlPoolException extends customError_1.CustomError {
    constructor() {
        super(`No directory node url was provided`, 400);
    }
}
exports.DirectoryNodeUrlPoolException = DirectoryNodeUrlPoolException;
class FilteredNodeUrlPoolEmptyError extends customError_1.CustomError {
    constructor(poolName) {
        super(`All node URLs were filtered out for pool "${poolName}". Update node URL filters or pool configuration.`, 400);
    }
}
exports.FilteredNodeUrlPoolEmptyError = FilteredNodeUrlPoolEmptyError;
class InvalidTransactionFormatException extends customError_1.CustomError {
    constructor() {
        super(`The transaction is not in the right format`, 400);
    }
}
exports.InvalidTransactionFormatException = InvalidTransactionFormatException;
class GetTransactionRidException extends customError_1.CustomError {
    constructor(error) {
        super(`"Error occurred while getting transaction RID:", ${error}`, 400);
    }
}
exports.GetTransactionRidException = GetTransactionRidException;
class TxRejectedError extends Error {
    constructor(rejectReason) {
        super(`Transaction was rejected, ${rejectReason}`);
        this.name = "TxRejectedError";
        this.fullReason = rejectReason;
        const result = (0, formatter_1.matchRellErrorString)(rejectReason);
        this.shortReason = result.shortReason;
        this.rellLine = result.rellLine;
        this.operation = result.operation;
    }
}
exports.TxRejectedError = TxRejectedError;
class UnexpectedStatusError extends customError_1.CustomError {
    constructor(status, error) {
        let errorMessage = `Unexpected status code from server. Code: ${status}.`;
        if (status === null) {
            super(errorMessage, 500); // default status code
        }
        else {
            if (error) {
                errorMessage += ` Message: ${error}.`;
            }
            super(errorMessage, status);
        }
    }
}
exports.UnexpectedStatusError = UnexpectedStatusError;
class InvalidTxRidException extends customError_1.CustomError {
    constructor(txRID) {
        super(`expected length 32 of txRID, but got ${txRID && txRID.length}`, 400);
    }
}
exports.InvalidTxRidException = InvalidTxRidException;
class SerializedTransactionFormatException extends customError_1.CustomError {
    constructor() {
        super(`messageHash is not a Buffer`, 400);
    }
}
exports.SerializedTransactionFormatException = SerializedTransactionFormatException;
class GetBridFromChainException extends Error {
    constructor(chainId, reason) {
        super(`Error resolving BRID for chainId ${chainId}, reason: ${reason}`);
    }
}
exports.GetBridFromChainException = GetBridFromChainException;
//# sourceMappingURL=errors.js.map